import {
    Features,
    useFeatureFlagValue,
} from '@experiences/feature-flags';
import { useMemo } from 'react';

import useCheckLicense from '../../../common/hooks/useCheckLicense';

export type CreditsPlan = 'community' | 'basic';

/**
 * Which plan's Credits experience the organization gets, if any. Each plan rolls out on its own flag; every
 * surface that swaps to (or hides itself for) the Credits experience reads this rather than repeating the checks.
 */
export const useCreditsExperience = (): { plan: CreditsPlan | undefined } => {
    const enableCommunityRevamp = useFeatureFlagValue(Features.EnableCommunityRevampExperience.name);
    const enableBasicPlan = useFeatureFlagValue(Features.EnableBasicPlanExperience.name);
    const {
        isCommunity, isBasic,
    } = useCheckLicense();

    const plan = useMemo<CreditsPlan | undefined>(() => {
        if (enableCommunityRevamp && isCommunity) {
            return 'community';
        }
        if (enableBasicPlan && isBasic) {
            return 'basic';
        }
        return undefined;
    }, [ enableCommunityRevamp, enableBasicPlan, isCommunity, isBasic ]);

    return { plan };
};
